import { Reorder as ReorderComponent } from 'features/CustomFieldsReorder';

const CustomFieldsReorderPage = (): JSX.Element => <ReorderComponent />;

export default CustomFieldsReorderPage;
